import { onMouseLeave } from '~/core/mouse-events/onMouseLeave';
import { onMouseMove } from '~/core/mouse-events/onMouseMove';
import { onMousewheel } from '~/core/mouse-events/onMousewheel';
import { BaseChartAPIProps } from '~/types/create.types';

import { chartStore } from '../chart-store/chartStore';
import { TimeScaleReturn } from '../time-scale/timeScale';

export const listenerModel = (
  canvasElement: HTMLCanvasElement,
  timeScale: TimeScaleReturn
) => {
  const zoomFunc = (event: WheelEvent) => onMousewheel(event, timeScale);
  const mouseMove = (event: MouseEvent) =>
    onMouseMove(event, chartStore.getState().base as BaseChartAPIProps);
  const mouseLeave = (event: MouseEvent) =>
    onMouseLeave(event, chartStore.getState().base as BaseChartAPIProps);

  // Future listeners like mouse down for panning and mouse hover can go in here
  const setListeners = (isSet: boolean) => {
    if (isSet) {
      canvasElement.addEventListener('wheel', zoomFunc);
      canvasElement.addEventListener('mousemove', mouseMove);
      canvasElement.addEventListener('mouseleave', mouseLeave);
      return;
    }
    canvasElement.removeEventListener('wheel', zoomFunc);
    canvasElement.removeEventListener('mousemove', mouseMove);
    canvasElement.removeEventListener('mouseleave', mouseLeave);
  };

  return { setListeners };
};
